import { useCallback, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { ShieldX, LogOut, ArrowLeft, RefreshCw } from "lucide-react";

export const AccessDenied = () => {
  const { user, logout, refreshSession } = useAuth();
  const [checking, setChecking] = useState(false);

  // A reload can reuse the five-minute session cookie cache and show this page
  // again after a grant. This reads the session past the cache, so a tab
  // granted seconds ago lets the user in at once.
  const checkAgain = useCallback(async () => {
    setChecking(true);
    try {
      await refreshSession();
    } finally {
      setChecking(false);
    }
  }, [refreshSession]);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center bg-background p-6">
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <div className="mb-6 flex size-20 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
          <ShieldX className="size-10" />
        </div>

        <h1 className="mb-2 text-2xl font-semibold text-foreground">
          No tabs granted yet
        </h1>

        <p className="mb-6 text-muted-foreground">
          Your staff account can sign in here, but no dashboard tab has been
          granted to it. Ask a Dashboard IAM holder to grant the tabs you need.
        </p>

        {user && (
          <p className="mb-6 rounded-lg border border-border bg-muted/50 px-4 py-2 text-sm text-muted-foreground">
            Signed in as{" "}
            <span className="font-medium text-foreground">{user}</span>
          </p>
        )}

        <div className="flex gap-3">
          <Button onClick={() => void checkAgain()} disabled={checking} className="gap-2">
            <RefreshCw className={checking ? "size-4 animate-spin" : "size-4"} />
            {checking ? "Checking..." : "Check again"}
          </Button>
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="gap-2"
          >
            <ArrowLeft className="size-4" />
            Go Back
          </Button>
          <Button variant="destructive" onClick={logout} className="gap-2">
            <LogOut className="size-4" />
            Sign Out
          </Button>
        </div>

        <p className="mt-8 text-xs text-muted-foreground">
          Grants take effect on your next request. If a tab was just granted,
          choose Check again.
        </p>
      </div>
    </div>
  );
};
